export const DOMAIN_AI_FILE_SEARCH = "AI_FILE_SEARCH";
